// extracted by mini-css-extract-plugin
export default {"wrapper":"Ir-z","response":"Jr-z","error":"Kr-z","disabled":"Lr-z","buttons":"Mr-z","feedbackQuestionSection":"Nr-z","yesNoWrapper":"Or-z"};